import { render, staticRenderFns } from "./EditCompanyModal.vue?vue&type=template&id=f96ae7f6&scoped=true"
import script from "./EditCompanyModal.vue?vue&type=script&lang=js"
export * from "./EditCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./EditCompanyModal.vue?vue&type=style&index=0&id=f96ae7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ae7f6",
  null
  
)

export default component.exports